import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../components/primitives/SMLButton';
import { withBrandWord } from '../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HomeSetupCardProps {
  icon: IconDefinition;
  title: string;
  body: string;
  cta: string;
  onAction: () => void;
  /** Inside a block the card has no frame of its own (design a2). */
  isBare?: boolean;
}

/** A block with no data shows one setup card with one call to action (design a2, b2). */
const HomeSetupCardComponent: React.FC<HomeSetupCardProps> = ({ icon, title, body, cta, onAction, isBare = false }) => (
  <div className={clsx(styles.setupCard, isBare && styles.setupCardBare)}>
    <span className={styles.setupIcon}>
      <FontAwesomeIcon icon={icon} />
    </span>
    <div className={styles.setupText}>
      <b>{withBrandWord(title)}</b>
      <p>{withBrandWord(body)}</p>
      <SMLButton variant="primary" onClick={onAction}>
        {cta}
      </SMLButton>
    </div>
  </div>
);

export const HomeSetupCard = TypedMemo(HomeSetupCardComponent);
